import { ApiService } from '~/shared/api'

import type { QueryParams } from '~/shared/interfaces/params'
import type { FilterFieldsModel } from '~/models/filters'
import { VacancyInterlinksModel } from '~/models/vacancy'
import { unwrapToModels } from '~/shared/utils/response'
import type { UnknownObject } from '~/shared/interfaces'
import type { InterlinksFiltersParams } from '~/types/interlinks'

export interface HumanReadableUrlFilters {
  filters?: Record<string, string | string[] | boolean>
}

export class VacanciesFiltersService extends ApiService {
  readonly urls = {
    vacanciesFilters: '/api/v1/yavagro/vacancies/filters',
    interlinkFilters: '/api/v1/yavagro/vacancies/interlink-filters',
    readableUrl: `/api/v1/yavagro/get-filters-from-human-readable-url`,
  }

  async getAccountVacanciesFilters(
    params?: QueryParams,
    signal?: AbortSignal
  ): Promise<Array<FilterFieldsModel>> {
    const res = await this.http.request<{ data?: FilterFieldsModel[] }>({
      url: this.urls.vacanciesFilters,
      params,
      signal,
    })
    return res.data?.data ?? []
  }

  async searchItems(value: string, field: string, region: string): Promise<FilterFieldsModel | null> {
    const res = await this.http.request<{ data?: FilterFieldsModel }>({
      url: this.urls.vacanciesFilters,
      params: { [`${field}|search`]: value, region },
    })
    return res.data?.data ?? null
  }

  async getFiltersFromHumanReadableUrl(
    params?: UnknownObject
  ): Promise<HumanReadableUrlFilters | ''> {
    const res = await this.http.request<{ result?: HumanReadableUrlFilters }>({
      url: this.urls.readableUrl,
      params,
    })
    return res.data?.result ?? ''
  }

  async getVacanciesInterlinks(
    params: InterlinksFiltersParams = {}
  ): Promise<VacancyInterlinksModel[]> {
    try {
      const res = await this.http.request({
        url: this.urls.interlinkFilters,
        params,
      })

      return unwrapToModels(res.data, VacancyInterlinksModel)
    } catch {
      return []
    }
  }
}
